import React from 'react'
import BaseIcon from 'react-icon-base'

const MV = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>MV</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <rect id="c" width="20" height="14" x=".5" y=".5" rx="2" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#00297B" xlinkHref="#a" />
      <g fillRule="nonzero" mask="url(#b)">
        <g transform="translate(-1)">
          <path fill="#D21034" d="M.037.037h22.388v14.925H.037z" />
          <path fill="#007E3A" d="M3.769 3.769h15.925v7.463H3.769z" />
          <circle cx="12.164" cy="7.5" r="2.488" fill="#FFF" />
          <circle cx="13.097" cy="7.5" r="2.488" fill="#007E3A" />
        </g>
      </g>
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#c" />
    </g>
  </BaseIcon>
)

export default MV
